import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import THEME from 'theme';
import { Price } from 'components';
import { Button, Heading } from 'components/chroma';
import { TextSmall } from 'components/chroma/extended';
import { PaymentFrequency } from 'scenes/common/types';
import { DEFAULT_HEADING_SIZES } from 'scenes/common/helpers/fonts';
import { getInstalmentFootnote } from 'scenes/common/helpers/insuranceInfo';

const QuoteInformationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -10px;
`;

const PriceFootnoteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
`;

const SwitchLinkWrapper = styled.div`
  p {
    color: ${THEME.LINK.DEFAULT} !important;
  }
`;

export const PriceWithFrequencySwitch: FunctionComponent<{
  paymentFrequency: PaymentFrequency;
  coverType: string;
  displayPrice: string;
  monthlyPriceSum: string;
  savedAmount: number;
  monthlyPaymentPreselected: boolean;
  onSwitchPaymentFrequency: () => void;
}> = ({
  paymentFrequency,
  coverType,
  displayPrice,
  monthlyPriceSum,
  savedAmount,
  monthlyPaymentPreselected,
  onSwitchPaymentFrequency,
}) => (
  <>
    <QuoteInformationContainer>
      <div>
        <Heading
          size={3}
          margin={{ bottom: 0, right: 2 }}
          fontSize={DEFAULT_HEADING_SIZES}
        >
          Pay {paymentFrequency}
        </Heading>
        <Heading size={3} margin={{ bottom: 0, right: 2 }}>
          {coverType}
        </Heading>
      </div>
      <Price amount={displayPrice} footnoteSymbol="" />
    </QuoteInformationContainer>

    <PriceFootnoteWrapper>
      <TextSmall weight={400} margin={{ top: 0, bottom: 0 }}>
        Includes GST, government charges, and any discount.
      </TextSmall>
      <TextSmall weight={400} margin={{ top: 0, bottom: 0 }}>
        {getInstalmentFootnote(
          monthlyPaymentPreselected,
          monthlyPriceSum,
          savedAmount
        )}
      </TextSmall>

      <Button link margin={{ top: 0 }} onClick={onSwitchPaymentFrequency}>
        <SwitchLinkWrapper>
          <TextSmall margin={{ top: 0 }}>
            Switch to{' '}
            {paymentFrequency === PaymentFrequency.Annually
              ? PaymentFrequency.Monthly
              : PaymentFrequency.Annually}
          </TextSmall>
        </SwitchLinkWrapper>
      </Button>
    </PriceFootnoteWrapper>
  </>
);
